import React from 'react'

const CrossOut = () => (
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M40 1.247L38.755 0 20 18.753 1.246 0 0 1.247 18.754 20 0 38.753 1.246 40 20 21.244 38.755 40 40 38.753 21.246 20z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

export default CrossOut
